import { createContext, use } from 'react'

export type Density = 'compact' | 'comfortable'

export const DENSITY_STORAGE_KEY = 'density'

export const DensityContext = createContext<{
  density: Density
  setDensity: (next: Density) => void
} | null>(null)

/**
 * Read and change row density.
 *
 * Throws outside its provider rather than defaulting. A silent default means a
 * toggle that appears to work and changes nothing, which is far harder to
 * notice than an error.
 */
export function useDensity() {
  const context = use(DensityContext)
  if (!context) throw new Error('useDensity must be used inside a DensityProvider')
  return context
}
